import { useState } from "react";

import { Flare } from "@mui/icons-material";
import {
  Button,
  ButtonProps,
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
} from "@mui/material";

import { cn, html } from "@utils/tailwind";

import "./StyledComponents.css";

export const Contained = html.div`px-3 sm:px-6 2xl:w-[95%] w-full mx-auto`;

export type StyledButtonProps = ButtonProps & {
  outlined?: boolean;
  cta?: boolean;
  to?: string;
  danger?: boolean;
  loading?: boolean;
  disabled?: boolean;
  replace?: boolean;
  state?: any;
};

export const StyledButton = ({
  outlined,
  cta,
  danger,
  loading,
  disabled,
  className,
  ...props
}: StyledButtonProps) => (
  <Button
    loading={loading}
    loadingPosition="end"
    disabled={loading || disabled}
    {...props}
    className={cn(
      "px-4 no-underline transition-all duration-200 shadow-sm text-primary-500 hover:shadow-md hover:bg-primary-100",
      !cta && !outlined && !danger && "bg-primary-100",
      disabled && "shadow-none text-neutral-500",
      cta && "text-white bg-primary-500 hover:bg-primary-600",
      cta && disabled && "bg-primary-400 text-primary-100",
      outlined &&
        "border-2 border-solid shadow-none border-primary-200 hover:border-primary-400",
      outlined && disabled && "border-neutral-200",
      danger &&
        "border-2 border-solid border-transparent shadow-none text-neutral-700 hover:bg-white hover:text-red-600 hover:border-red-400",
      className
    )}
  />
);

export const TextButton = html(
  Button
)`normal-case text-neutral-600 font-normal min-w-0 px-2 py-1 rounded-none underline hover:underline underline`;

export const ConfirmButton = ({ confirm, children, onClick, ...props }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <>
      <StyledButton {...props} onClick={() => setOpen(true)}>
        {children}
      </StyledButton>
      <Dialog open={open} onClose={close}>
        <DialogTitle>{confirm}</DialogTitle>
        <DialogActions>
          <StyledButton outlined onClick={close}>
            Cancel
          </StyledButton>
          <StyledButton
            cta
            onClick={() => {
              onClick();
              close();
            }}
          >
            Confirm
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const SmallIndexCounter = html.div`flex items-center justify-center w-8 h-8 mr-1 text-sm rounded-full bg-slate-50 text-slate-700`;

export const BeaconIcon = html(
  Flare
)`bg-white text-lg text-blue-600 rounded-md p-px`;

export const FixedHeightScrollLastChild = html(
  Contained
)`fixed-height-scroll-last-child`;

export const TableCardContainer = html(Card)`table-card-container`;
